exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".repair-option{height:40px;line-height:40px;font-size:1.3rem}.repair-option span{font-size:1.3rem}", ""]);

// exports
